import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import * as MenuListUI from 'components/MenuList';
import PopoverCard from 'components/PopoverCard';
import { NavMenuContext } from './NavMenu';
function NavMenuList(_ref) {
  var children = _ref.children;
  var _useContext = useContext(NavMenuContext),
    popover = _useContext.popover,
    itemList = _useContext.itemList;
  return /*#__PURE__*/React.createElement(PopoverCard, _extends({
    renderInPlace: true,
    renderWhenClosed: true,
    isOpen: popover.isOpen
  }, popover.props, {
    ref: popover.setRef,
    id: itemList.listId,
    arrow: popover.arrow
  }), /*#__PURE__*/React.createElement(MenuListUI.Wrapper, null, children));
}
export default NavMenuList;